module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.resourcecenters.red-1ef20fb5cf62c8c96ed5f2a01b03305a.svg";